@if (jobLinkerCols && jobLinkers) {
  <p-table class="config-table" #dt
    [columns]="jobLinkerCols"
    [value]="jobLinkers"
    [resizableColumns]="true"
    [scrollable]="true">
    <ng-template #colgroup let-columns>
      <colgroup>
      @for (col of columns; track col) {
        <col />
      }
    </colgroup>
  </ng-template>
  <ng-template #header let-columns>
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field">
          {{col.header}}
          @if (showAdminControls && col.field != '') {
            <p-sortIcon [field]="col.field"></p-sortIcon>
          }
        </th>
      }
    </tr>
    @if (showAdminControls) {
      <tr>
        @for (col of columns; track col) {
          <th pResizableColumn>
            @switch (col.field) {
              @case ('consumer') {
                <div>
                  <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;"
                    />
                  </div>
                }
                @case ('wellName') {
                  <div>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;"
                      />
                    </div>
                  }
                  @case ('apiNumber') {
                    <div>
                      <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;"
                        />
                      </div>
                    }
                    @case ('jobType') {
                      <div style="width: 100%;">
                        <p-multiSelect [options]="jobTypes" placeholder="All Job Types" (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body"></p-multiSelect>
                      </div>
                    }
                    @case ('vendorJobNames') {
                      <div style="width: 100%;">
                        <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;"
                          />
                        </div>
                      }
                      @case ('consumerJobStatus') {
                        <div style="width: 100%;">
                          <p-multiSelect [options]="statuses" placeholder="All Statuses" (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body"></p-multiSelect>
                        </div>
                      }
                    }
                  </th>
                }
              </tr>
            }
          </ng-template>
          <ng-template #body let-jobLinker>
            <tr>
              <td>{{jobLinker.consumer}}</td>
              <td>{{jobLinker.wellName}}</td>
              <td>{{jobLinker.apiNumber}}</td>
              <td>{{jobLinker.jobType}}</td>
              <td>{{jobLinker.consumerJobStartTime | date:'medium'}}</td>
              <td>{{jobLinker.consumerJobStatus}}</td>
              @if (showAdminControls) {
                <td class="wbCell"
                [pTooltip]="jobLinker.vendorJobNames" tooltipPosition="top" tooltipEvent="hover">{{jobLinker.vendorJobNames}}</td>
              }
              @if (showAdminControls) {
                <td>
                  <i class="far fa-edit" style="margin-right:2px;" (click)="editJobLinker(jobLinker)"></i>
                  <!-- <i class="far fa-trash-alt" (click)="deleteJobLinker(jobLinker)"></i> -->
                </td>
              }
            </tr>
          </ng-template>
          @if (showAdminControls) {
            <ng-template #paginatorleft>
              Showing {{(dt.totalRecords) < 1 ? 0 : ((dt.first ?? 0) + 1)}} to
              {{(dt.totalRecords) > 0 ? ((((dt.rows ?? 0) + (dt.first ?? 0)) <= (dt.totalRecords)) ? ((dt.rows ?? 0) + (dt.first ?? 0)) :
              (dt.totalRecords)) : 0}} of {{dt.totalRecords}} entries
            </ng-template>
          }
          @if (showAdminControls) {
            <ng-template #summary>
              <button pButton type="button" (click)="addJobLinker()" class="add-button">
                <i pButtonIcon class="fa fa-plus"></i>
                <span pButtonLabel>Add</span>
              </button>
            </ng-template>
          }
        </p-table>
      }
      @if (!jobLinkers) {
        <p>No Job Linking Data to show</p>
      }

